export default __webpack_public_path__ + "static/media/discover.f16f4ace.svg";